import * as R from "ramda";
import React, {Component} from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import Api from "../../../../../Services/Api";
import {HttpStatus, Pembanding, Status} from "../../../../common/Constants";
import {mapToObjectDDL} from "../../../../common/mapper";
import DateRange from "../../common/dateRange";
import M from "moment";

class Filter extends Component {
    countCetakanOptions = [
        {
            label: Pembanding.LEBIH_BESAR,
            value: Pembanding.LEBIH_BESAR,
        },
        {
            label: Pembanding.LEBIH_BESAR_SAMA_DENGAN,
            value: Pembanding.LEBIH_BESAR_SAMA_DENGAN,
        },
        {
            label: Pembanding.SAMA_DENGAN,
            value: Pembanding.SAMA_DENGAN,
        },
        {
            label: Pembanding.LEBIH_KECIL,
            value: Pembanding.LEBIH_KECIL,
        },
        {
            label: Pembanding.LEBIH_KECIL_SAMA_DENGAN,
            value: Pembanding.LEBIH_KECIL_SAMA_DENGAN,
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            bankOptions: [],
            documentOptions: [],
            relationOptions: [],
        };
    }

    async componentDidMount() {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const bankOptions = [];
        const documentOptions = [];
        const relationOptions = [];
        const responses = await Promise.all([
            Api.create("NAGAMAS_MASTER_DATA").getAllMasterBank({
                paramFilters: {
                    kodecabang: [this.props.kodeCabang],
                    status: Status.ACTIVE,
                },
            }),
            Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
                paramFilters: {
                    bizparCategory: "DOCUMENT_TYPE",
                    status: Status.ACTIVE,
                },
            }),
            Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
                paramFilters: {
                    bizparCategory: "RELATION_TYPE",
                    status: Status.ACTIVE,
                },
            }),
        ]);

        responses.forEach((response, idx) => {
            if (idx === 0) {
                if (response.data.status === HttpStatus.SUCCESS) {
                    bankOptions.push(
                        ...response.data.data.map((d) => mapToObjectDDL(d.bankName, d.bankCode))
                    );
                }
            } else if (idx === 1) {
                if (response.data.status === HttpStatus.SUCCESS) {
                    documentOptions.push(...response.data.data.map((d) => mapToObjectDDL(d.value, d.key)));
                }
            } else {
                if (response.data.status === HttpStatus.SUCCESS) {
                    relationOptions.push(...response.data.data.map((d) => mapToObjectDDL(d.value, d.key)));
                }
            }
        });

        this.setState((prevValue) => ({
            ...prevValue,
            bankOptions,
            documentOptions,
            relationOptions,
            loading: false,
        }));
    }

    getDataValue(fieldName) {
        return !R.isNil(this.props.data) && this.props.data[fieldName]
            ? this.props.data[fieldName]
            : null;
    }

    render() {
        return (
            <SimpleModal
                title="Filter Search"
                visible={this.props.visible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <DateRange
                            data={this.props.data?.[`tanggal${this.props.tab}`]}
                            label={`Tanggal ${this.props.tab}`}
                            startDateName="tanggalAwal"
                            endDateName="tanggalAkhir"
                            onStartDateChange={(name, value) =>
                                this.props.onDateChange(`tanggal${this.props.tab}`, name, M(value).format("DD-MM-YYYY"))
                            }
                            onEndDateChange={(name, value) =>
                                this.props.onDateChange(`tanggal${this.props.tab}`, name, M(value).format("DD-MM-YYYY"))
                            }
                        />
                        <SimpleInput
                            id={`input_text_nomor_${this.props.tab.toLowerCase()}`}
                            name="paymentBankId"
                            label={`Nomor ${this.props.tab}`}
                            value={this.getDataValue("paymentBankId")}
                            onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                        />
                        <SimpleDDL
                            id="select_options_jenis_dokumen"
                            name="jenisDokumen"
                            label="Jenis Dokumen"
                            box="search"
                            value={this.getDataValue("jenisDokumen")}
                            isClearable
                            options={this.state.documentOptions}
                            onChange={(value, {name}) => this.props.onValueChange(name, value)}
                        />
                        <SimpleInput
                            id="input_text_no_doc_ref1"
                            name="nomorDokumenRef1"
                            label="Nomor Dokument Ref 1"
                            value={this.getDataValue("nomorDokumenRef1")}
                            onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                        />
                        <DateRange
                            data={this.props.data?.tanggalDokumenRef1}
                            label="Tanggal Dokumen Ref 1"
                            startDateName="tanggalAwal"
                            endDateName="tanggalAkhir"
                            onStartDateChange={(name, value) =>
                                this.props.onDateChange("tanggalDokumenRef1", name, value)
                            }
                            onEndDateChange={(name, value) =>
                                this.props.onDateChange("tanggalDokumenRef1", name, value)
                            }
                        />
                        <SimpleInput
                            id="input_text_no_doc_ref2"
                            name="nomorDokumenRef2"
                            label="Nomor Dokument Ref 2"
                            value={this.getDataValue("nomorDokumenRef2")}
                            onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                        />
                        <DateRange
                            data={this.props.data?.tanggalDokumenRef2}
                            label="Tanggal Dokumen Ref 2"
                            startDateName="tanggalAwal"
                            endDateName="tanggalAkhir"
                            onStartDateChange={(name, value) =>
                                this.props.onDateChange("tanggalDokumenRef2", name, value)
                            }
                            onEndDateChange={(name, value) =>
                                this.props.onDateChange("tanggalDokumenRef2", name, value)
                            }
                        />
                        <SimpleDDL
                            id="select_options_nama_bank"
                            name="bankId"
                            label="Nama Bank"
                            box="search"
                            isClearable
                            options={this.state.bankOptions}
                            value={this.getDataValue("bankId")}
                            onChange={(value, {name}) => this.props.onValueChange(name, value)}
                        />
                        <SimpleInput
                            id="input_text_no_rekening"
                            name="nomorRekening"
                            label="No Rekening"
                            value={this.getDataValue("nomorRekening")}
                            onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                        />
                        <SimpleInput
                            id="input_text_nama_rekening"
                            name="namaRekening"
                            label="Nama Rekening"
                            value={this.getDataValue("namaRekening")}
                            onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                        />
                        <SimpleInput
                            id="input_text_terima_dari"
                            name="namaOrangTransaksi"
                            label={this.props.tab === "BBM" ? "Terima Dari" : "Bayar Kepada"}
                            value={this.getDataValue("namaOrangTransaksi")}
                            onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                        />
                        <SimpleDDL
                            id="select_options_jenis_relasi"
                            name="jenisRelasi"
                            label="Jenis Relasi"
                            box="search"
                            isClearable
                            value={this.getDataValue("jenisRelasi")}
                            options={this.state.relationOptions}
                            onChange={(value, {name}) => this.props.onValueChange(name, value)}
                        />
                        <SimpleTextArea
                            id="input_text_guna_membayar"
                            name="gunaMembayar"
                            label="Guna Membayar"
                            typeInputCase="normal"
                            value={this.getDataValue("gunaMembayar")}
                            onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                        />
                        <SimpleTextArea
                            id="input_text_keterangan"
                            name="keterangan"
                            label="Keterangan"
                            typeInputCase="normal"
                            value={this.getDataValue("keterangan")}
                            onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                        />
                        <div style={{display: "flex", gap: "20px", alignItems: "center"}}>
                            <SimpleDDL
                                id="select_options_count_cetakan"
                                name="operator"
                                label="Count Cetakan"
                                box="search"
                                containerclassname="flex-1"
                                options={this.countCetakanOptions}
                                value={this.getDataValue("operator")}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleInput
                                id="input_text_number"
                                name="count"
                                label="Number"
                                box="onlyNumber"
                                value={this.getDataValue("count")}
                                onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                            />
                        </div>
                        <div style={{textAlign: "center"}}>
                            <SimpleButton secondary onClick={this.props.onClear}>
                                Hapus
                            </SimpleButton>
                            <SimpleButton onClick={this.props.onSubmit}>Terapkan</SimpleButton>
                        </div>
                        {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
                    </ModalContainer>
                }
            />
        );
    }
}

export default Filter;
